import $ from "jquery";
import Glide from '@glidejs/glide';
export default class Carousel {
    static mount() {
        $(function () {
            $('.ce-carousel').each(function () {
                new Carousel($(this));
            });
        });
    }
    constructor($targetNode) {
        this.$targetNode = $targetNode;
        const settings = $targetNode.data("settings");
        const $glideTarget = $('.glide', $targetNode);
        $targetNode.addClass("carousel-mounted");
        this.$slides = $(".glide__slide", $targetNode);
        this.$categoryItems = $(".ce-carousel__category", $targetNode);
        const glideSettings = Object.assign({ type: 'carousel', bound: false, startAt: 0, focusAt: 0, rewind: true, gap: 10, perView: 1, autoplay: false, hoverpause: true, breakpoints: {} }, settings);
        this.glide = new Glide($glideTarget[0], glideSettings);
        this.glide.mount();
        this.glide.on('run.after', () => {
            this.calcActiveCategory();
        });
        this.calcActiveCategory();
    }
    calcActiveCategory() {
        this.$categoryItems.removeClass('ce-carousel__category--active');
        const currentCategoryId = this.$slides[this.glide.index].dataset.category;
        const activeItem = $(".ce-carousel__category[data-categoryid=" + currentCategoryId + "]", this.$targetNode);
        activeItem.addClass('ce-carousel__category--active');
    }
}
